import { createRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Icon from '@mdi/react';
import { mdiMinusCircle, mdiPlusCircle } from '@mdi/js';
import Checkbox from 'client/components/GDS/Checkbox/Checkbox';

import styles from './TreeControls.module.scss';

const TreeControls = ({ openAll, onOpenAll, toggleAllLayers, isAllNodesChecked, indeterminate, ...props }) => {
    const intl = useIntl();
    const collapseRef = createRef();

    const handleCollapseClick = () => {
        if (collapseRef?.current) {
            collapseRef.current.focus({
                preventScroll: true
            });
        }
        onOpenAll();
    };

    const handleCollapseKeypress = evt => {
        if (evt.keyCode === 13 || evt.key === 'Enter') {
            handleCollapseClick();
        }
    };

    return (
        <div className={styles.controls} data-testid={props['data-testid']}>
            <Checkbox
                onChange={toggleAllLayers}
                label={intl.formatMessage({ id: 'treeControls.toggleAll' })}
                checked={isAllNodesChecked}
                indeterminate={indeterminate}
                data-testid={'treeControls-ToggleAll'}
            >
            </Checkbox>
            <div
                className={styles.collapseIcons}
                tabIndex={0}
                role="button"
                onClick={handleCollapseClick}
                ref={collapseRef}
                onKeyDown={handleCollapseKeypress}
                data-testid={props['data-testid'] ? props['data-testid'] + '-expand' : null}
            >
                <Icon className={styles.collapseIcon} path={!openAll ? mdiPlusCircle : mdiMinusCircle} size={1} />
                <span className={styles.collapseText}>{
                    !openAll
                        ? intl.formatMessage({ id: 'treeControls.expandAll' })
                        : intl.formatMessage({ id: 'treeControls.collapseAll' })
                }</span>
            </div>
        </div>
    );
};

TreeControls.propTypes = {
    openAll: PropTypes.bool,
    onOpenAll: PropTypes.func.isRequired,
    isAllNodesChecked: PropTypes.bool,
    indeterminate: PropTypes.bool,
    toggleAllLayers: PropTypes.func.isRequired,
    'data-testid': PropTypes.string
};

TreeControls.defaultProps = {
    openAll: false,
    isAllNodesChecked: false,
    indeterminate: false,
    'data-testid': 'treeControls'
};

export default TreeControls;
